import { handleActions } from "redux-actions";
import {
  getUsersAsync,
  changeUserBlockStatusAsync,
  changeUsersFilterAsync,
  clearUsersErrorAsync,
} from "../actions/users.actions";

import languages from "../../common/languages";

const initialState = {
  state: [],
  count: 0,
  filter: {
    registerAtFrom: null,
    registerAtTo: null,
    verifyed: "",
    blocked: "",
    phone: "",
  },
  error: null,
};

export default handleActions(
  {
    [getUsersAsync.success]: (s, { payload: { data: RequestedData } }) => ({
      ...s,
      state: RequestedData.success ? RequestedData.result.users : [],
      count: RequestedData.success ? RequestedData.result.count : 0,
      error: RequestedData.success
        ? null
        : RequestedData.error
        ? RequestedData.error
        : languages.errors.default,
    }),
    [changeUserBlockStatusAsync.success]: (
      s,
      { payload: { data: RequestedData } }
    ) => ({
      ...s,
      state: RequestedData.success
        ? s.state.map((v) =>
            v._id == RequestedData.result.user._id
              ? { ...v, blocked: RequestedData.result.user.blocked }
              : v
          )
        : s.state,
      error: RequestedData.success
        ? null
        : RequestedData.error
        ? RequestedData.error
        : languages.errors.default,
    }),
    [changeUsersFilterAsync.success]: (s, { payload: { filter } }) => ({
      ...s,
      filter: filter,
    }),
    [clearUsersErrorAsync.success]: (s, a) => ({
      ...s,
      error: null,
    }),

    [getUsersAsync.failed]: (s, a) => ({
      ...s,
      error: languages.errors.default,
    }),
    [changeUserBlockStatusAsync.failed]: (s, a) => ({
      ...s,
      error: languages.errors.default,
    }),
  },
  initialState
);
